import * as React from "react";

const SvgEyeOff = (props) => (
  <svg
    width={23}
    height={23}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.365 8.625h.135c.779 0 1.453.285 2.021.854.57.569.854 1.242.854 2.021v.18l-3.01-3.055Zm-4.133.764c-.359.718-.539 1.422-.539 2.111 0 1.318.472 2.448 1.415 3.392.944.943 2.074 1.415 3.392 1.415.689 0 1.393-.18 2.111-.54l-1.482-1.482c-.24.06-.45.09-.629.09-.779 0-1.453-.284-2.021-.854-.57-.569-.854-1.242-.854-2.021 0-.18.03-.39.09-.629L7.232 9.39Zm-5.3-5.301 1.213-1.213 16.98 16.98-1.213 1.213c-.15-.15-.621-.614-1.415-1.392-.794-.779-1.4-1.378-1.82-1.797-1.287.539-2.68.808-4.177.808-2.366 0-4.507-.658-6.424-1.976C3.16 15.393 1.782 13.656.943 11.5c.33-.779.846-1.64 1.55-2.583.704-.943 1.385-1.67 2.044-2.179-.36-.36-.86-.868-1.505-1.527-.644-.659-1.01-1.033-1.1-1.123ZM11.5 6.693c-.599 0-1.183.12-1.752.36L7.682 4.986c1.168-.449 2.44-.673 3.818-.673 2.366 0 4.5.658 6.401 1.976a11.097 11.097 0 0 1 4.11 5.211 11.711 11.711 0 0 1-3.279 4.537l-2.785-2.785c.24-.57.36-1.153.36-1.752 0-1.318-.472-2.448-1.415-3.392-.944-.943-2.074-1.415-3.392-1.415Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgEyeOff;
